class RateLimitingService {
    static get $inject() {
        return ['$uibModal']
    }

    constructor($uibModal) {
        this.modal = $uibModal

        this.rateLimitPendingResolvers = []
        this.isRateLimitModalOpen = false
    }

    wait(retryFun, ttl) {
        const promise = new Promise(resolve => this.rateLimitPendingResolvers.push(resolve))
            .then(() => retryFun())

        if (!this.isRateLimitModalOpen) {
            this.isRateLimitModalOpen = true
            this.modal
                .open({
                    backdrop: 'static',
                    size: 'md',
                    keyboard: false,
                    component: 'rateLimitingModal',
                    resolve: {
                        ttl: () => ttl
                    }
                })
                .result
                .then(() => {
                    this.rateLimitPendingResolvers.forEach(resolver => resolver())
                    this.rateLimitPendingResolvers = []
                    this.isRateLimitModalOpen = false
                })
        }

        return promise
    }
}

angular.module('eficienciaFiscalModule').service('RateLimitingService', RateLimitingService)
